import { render, staticRenderFns } from "./StoryTerms.vue?vue&type=template&id=69a30a9c&scoped=true"
import script from "./StoryTerms.vue?vue&type=script&lang=js"
export * from "./StoryTerms.vue?vue&type=script&lang=js"
import style0 from "./StoryTerms.vue?vue&type=style&index=0&id=69a30a9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a30a9c",
  null
  
)

export default component.exports